export default __webpack_public_path__ + "static/media/youtility_logo.c9fd0d95.svg";